export default {
  custom_button: {
    continue: "Weiter",
  },
  text_inputs: {
    door_name: {
      placeholder: "Türklingelname (optional)",
    },
    company_name: {
      placeholder: "Firmenname (optional)",
    },
    note: {
      placeholder: "Lieferanweisungen hinzufügen z.B. bitte anrufen bei der Ankunft (optional)",
    },
    order_instruction: {
      placeholder: 'Bestellanweisungen eingeben...',
  },
  },
  error_messages: {
    update_profile_unsuccessful: "Deine persönlichen Daten konnten nicht aktualisiert werden",
  },
};
